import { render, staticRenderFns } from "./PersonalAuthor.vue?vue&type=template&id=1b5bb656&scoped=true&"
import script from "./PersonalAuthor.vue?vue&type=script&lang=js&"
export * from "./PersonalAuthor.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAuthor.vue?vue&type=style&index=0&id=1b5bb656&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5bb656",
  null
  
)

export default component.exports